__turbopack_context__.v({
  "className": "montserrat_27b5ea7d-module__Vxavgq__className",
});
